import React from 'react'
import PropTypes from 'prop-types'
import { TextField, Button } from '@material-ui/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import qs from 'querystring'
import connectPropTypes from './utilities/connectPropTypes'
import getField from './utilities/Data/getField'
import getAbsoluteUrlForCurrentHost from './utilities/getAbsoluteUrlForCurrentHost'
import Img from './components/Img'
import styles from './AddVerification.icss'

const mailToHref = ({ subject, body, to }) => {
	const params = qs.stringify({ subject, body })
	return `mailto:${to || ''}?${params}`
}

class AddVerification extends React.Component {
	constructor(props) {
		super(props)

		this.state = {}
		this.copiedTimer = undefined
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Get verified') })
		this.props.appShowBottomBar(false)
		this.props.appShowBottomNavBar(true)
		this.props.appBottomNavBarHandleClick(() => {
			this.props.history.goBack()
		})
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.copied && this.state.copied) {
			clearTimeout(this.copiedTimer)
			this.copiedTimer = setTimeout(() => {
				this.setState(() => ({
					copied: false
				}))
			}, 3000)
		}
	}

	render() {
		const verifyUrl = getAbsoluteUrlForCurrentHost(`/verify/${getField(this.props.user, 'userProfile.userName')}`)
		const message = this.context.translate('Hi guys,\n\nHelp me out and verify my profile @kitfit so I can increase my chance for early access!\n\n{verifyUrl}\n@kitfitcycling', { verifyUrl })
		return (
			<section>
				<div className={styles.pagePadding}>
					<h2 className={styles.header}>
						<span>{this.context.translate('Get verified by your friends')}</span>
						<span><Img content="/images/content/badges/half.svg" className={styles.headerImg} /></span>
					</h2>
					<p>
						{this.context.translate('To be first in line we need to know you are legit! Get at least 10 people to verify you to get your badge and improve your chances for early access!')}
					</p>
					<p>
						{this.context.translate('Click the email button below or copy and paste the text below and share with your friends so they can follow your link and help you out!')}
					</p>
					<div className={styles.messageWrapper}>
						<TextField
							multiline
							fullWidth
							name="messageEmail"
							label={this.context.translate('Message')}
							value={message}
							inputProps={{
								readOnly: true
							}}
						/>
					</div>
					<div className={styles.buttonWrapper}>
						<div className={styles.buttonSurround}>
							<Button
								variant="contained"
								classes={{ root: styles.button }}
								href={mailToHref({
									body: message,
									subject: this.context.translate('Verify my profile on Kitfit')
								})}
							>
								{this.context.translate('Open in email')}
							</Button>
						</div>
						<div className={styles.buttonSurround}>
							<CopyToClipboard text={message} onCopy={() => this.setState({ copied: true })}>
								<Button variant="contained" classes={{ root: styles.button }}>{this.state.copied ? this.context.translate('Copied!') : this.context.translate('Copy text to clipboard')}</Button>
							</CopyToClipboard>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

AddVerification.contextTypes = {
	translate: PropTypes.func
}

AddVerification.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appHeading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

export default connectPropTypes(AddVerification)



// WEBPACK FOOTER //
// ./src/AddVerification.jsx